<template>
  <div class="dashboard-container">
    <div style="min-width:1200px;">
    <el-row :gutter="10">
      <el-col :span="24" class="mb-15" v-if="data.Articles&&data.Articles.length">
        <div class="el-col-box">
          <!-- <div style="height:250px">
            <date></date>
          </div> -->
          <div class="articles">
            <div class="title">
              <div class="align-item">
                <el-image class="icon" :src="icon1"></el-image>
                <span>通知公告</span>
              </div>
              <div class="more" @click="more">查看更多</div>
            </div>
            <div class="content">
              <div v-for="item in data.Articles" :key="item.ArticleId">
                <div class="article-title" :title="item.Title" @click="toDetails(item.ArticleId)">{{item.Title}}</div>
                <div class="time">{{$commonJs.toDateString(item.PublishTime)}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
     <el-row :gutter="10">
      <el-col :span="14" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon2"></el-image>
            <span>今日实时数据</span>
          </div>
          <div>
            <el-row :gutter="15" style="margin-bottom:20px;">
              <el-col :span="6">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img1" class="title-img">报名学员
                  </div>
                  <div class="text-right">{{data.TodaySignStudentCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img2" class="title-img">培训学员
                  </div>
                  <div class="text-right">{{data.TodayTrainStudentCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img3" class="title-img">带教教练
                  </div>
                  <div class="text-right">{{data.TodayCoachCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img4" class="title-img">培训车辆
                  </div>
                  <div class="text-right">{{data.TodayCarCount||0}}</div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="mb-15">
              <el-col :span="12">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img5" class="title-img">科目二预约数量
                  </div>
                  <div class="text-right">{{data.Subject2BookCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="data-item">
                  <div class="text-left">
                    <img :src="img6" class="title-img">科目三预约数量
                  </div>
                  <div class="text-right">{{data.Subject3BookCount||0}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="5" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon2"></el-image>
            <span>累计汇总数据</span>
          </div>
          <div>
            <el-row :gutter="15" style="margin-bottom:15px;">
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">学员总数</div>
                  <div class="num">{{data.StudentCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">教练总数</div>
                  <div class="num">{{data.CoachCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2" style="margin-bottom:0;">
                  <div class="text">教练车总数</div>
                  <div class="num">{{data.CarCount||0}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="5" class="mb-15" v-if="UserType!=1">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon2"></el-image>
            <span>运营汇总数据</span>
          </div>
          <div>
            <el-row :gutter="15" style="margin-bottom:15px;">
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">合作驾校</div>
                  <div class="num">{{data.SchoolCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">实操设备</div>
                  <div class="num">{{data.DeviceCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2" style="margin-bottom:0;">
                  <div class="text">模拟设备</div>
                  <div class="num">{{data.SimulatorCount||0}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="5" class="mb-15" v-if="UserType==1">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon2"></el-image>
            <span>提醒信息</span>
          </div>
          <div>
            <el-row :gutter="15" style="margin-bottom:15px;">
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">待年审车辆</div>
                  <div class="num">{{data.ReviewCarCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2">
                  <div class="text">待继保车辆</div>
                  <div class="num">{{data.InsureCarCount||0}}</div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="data-item2" style="margin-bottom:0;">
                  <div class="text">投诉和评价</div>
                  <div class="num">{{data.ComEvaCount||0}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" v-if="UserType!=1">
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>学员名额出库趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart"></line-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>备案学员趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart2"></line-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>备案学时趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart3"></line-chart>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" v-else-if="UserType==1">
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>报名学员趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart4"></line-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>结业学员趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart5"></line-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="mb-15">
        <div class="el-col-box">
          <div class="align-item data-title">
            <el-image class="icon" :src="icon3"></el-image>
            <span>预约学员趋势</span>
          </div>
          <div>
            <line-chart ref="lineChart6"></line-chart>
          </div>
        </div>
      </el-col>
    </el-row>
    <list-dialog ref="listDialog" in-dialog selectable></list-dialog>
    <view-dialog ref="viewDialog"></view-dialog>
    </div>
  </div>
</template>

<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import date from "@/components/dashboard/cards/date";
import lineChart from "@/components/dashboard/charts/lineChart";
import listDialog from "@/components/dashboard/articles/listDialog";
import viewDialog from "@/components/dashboard/articles/viewDialog";
import api from "@/api/sy/user";
export default {
  components: {
    date,
    lineChart,
    listDialog,
    viewDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      icon1: require("../assets/speaker.png"),
      icon2: require("../assets/data.png"),
      icon3: require("../assets/chart.png"),
      img1: require("../assets/img1.png"),
      img2: require("../assets/img2.png"),
      img3: require("../assets/img3.png"),
      img4: require("../assets/img4.png"),
      img5: require("../assets/img5.png"),
      img6: require("../assets/img6.png"),
      UserType: loginInfo.UserType,
      loop: null,
      data: {
        Articles: [],
      },
    };
  },
  beforeMount() {
    let self = this;
    self.getData();
    this.loop = setInterval(() => {
      self.getData();
    }, 300000);
  },
  beforeDestroy() {
    clearInterval(this.loop);
  },
  methods: {
    getData() {
      api.getWorkbench().then(res => {
        if(res.Code==0) {
          this.data = res.Data;
          // this.data.Articles = [
          //   { ArticleId: 1, Title: "标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长标题很长", PublishTime: "2022-3-18 12:00:00" },
          //   { ArticleId: 2, Title: "通知标题", PublishTime: "2022-3-18 12:00:00" },
          // ];
          //   PlaceStat: [
          //     { Value: 2, Text: "03-12" },
          //     { Value: 3, Text: "03-11" },
          //     { Value: 5, Text: "03-10" },
          //     { Value: 3, Text: "03-09" },
          //     { Value: 6, Text: "03-08" },
          //     { Value: 5, Text: "03-07" },
          //     { Value: 2, Text: "03-06" },
          //   ],
          // }
          if(this.UserType!=1) {
            this.$refs.lineChart.initChart(this.data.PlaceStat,"","人数");
            this.$refs.lineChart2.initChart(this.data.RecordStudentStat,"","人数");
            this.$refs.lineChart3.initChart(this.data.RecordHourStat,"","学时");
          } else {
            this.$refs.lineChart4.initChart(this.data.SignStat,"","人数");
            this.$refs.lineChart5.initChart(this.data.GraduationStat,"","人数");
            this.$refs.lineChart6.initChart(this.data.BookStat,"","人数");
          }
        }
      })
    },
    toDetails(id) {
      this.$refs.viewDialog.openDetailsById(id);
    },
    more() {
      this.$refs.listDialog.open().then(that => {
        that.getData();
      });
    },
  }
};
</script>
<style  lang="scss" scoped>
.dashboard-container {
  padding: 32px 35px 15px;
  background-color: rgb(240, 242, 245);
  position: relative;
  height: calc(100vh - 84px);
  overflow: auto;
  .align-item {
    display: flex;
    align-items: center;
  }
  .data-title {
    height: 45px;
  }
  .icon {
    height: 18px;
    width: 18px;
    margin: 0 5px -2px 0;
  }
  .text-left {
    font-size: 18px;
    // color: rgb(76, 155, 44);
    color: #42b983;
    text-align: left;
    margin-bottom: 5px;
  }
  .text-right {
    text-align: right;
    font-size: 22px;
  }
  .data-item {
    padding: 5px 10px 5px;
    background-color: #f8f8f8;
    border-radius: 4px;
  }
  .data-item2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px 5px;
    background-color: #f8f8f8;
    border-radius: 4px;
    margin-bottom: 15px;
    height: 41px;
    .text {
      color: #42b983;
      font-size: 18px;
    }
    .num {
      font-size: 22px;
    }
  }
  .mb-15 {
    margin-bottom: 15px;
  }
  .more {
    cursor: pointer;
    &:hover {
      color: #666;
    }
  }
}
.title-img {
  height: 26px;
  margin-right: 5px;
  vertical-align: bottom;
}
.el-col-box {
  padding: 0 20px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card-panel-description {
  float: left;
  font-weight: bold;
  margin-left: 25px;

  .card-panel-text {
    line-height: 50px;
    color: rgba(0, 0, 0, 0.75);
    font-size: 18px;
  }
}
.articles {
  .title {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  .content {
    padding: 10px 0;
    & > div {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      height: 32px;
    }
    .article-title {
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: calc(100% - 100px);
      line-height: 32px;
      &:hover {
        color: #666;
      }
    }
    .time{
      width: 74px;
      font-size: 14px;
      color: #aaa;
      line-height: 32px;
    }
  }
}
</style>